import { useEffect, useMemo } from "react";
import { Map } from "leaflet";

import { MeasureConf } from "types/types";

import { orderBy, uniqBy } from "lodash-es";
import { TreeTrunkSvg } from "components/measures/TreeTrunkSvg";
import {
  applyPointLayerStyle,
  applyPointRadius,
  applyPolygonLayerStyle,
} from "utils/GeomanUtils";

interface Props {
  mapRef: Map;
  measureConfigs: MeasureConf[];
  radius?: number;
  measureConfigId?: number;
}

export function RenderMeasureConfigs(props: Props) {
  const { mapRef, measureConfigs, radius, measureConfigId } = props;
  const pointMeasureConfigs = measureConfigs.filter(
    (measureConfig) => measureConfig.measure.geometryType === "POINT"
  );

  const sortedMeasureConfigs = useMemo(() => {
    return orderBy(measureConfigs, ["zindex"], ["asc"]);
  }, [measureConfigs]);

  const uniqueMeasures = uniqBy(
    pointMeasureConfigs.map((measureConfig) => measureConfig.measure),
    "id"
  );

  useEffect(() => {
    sortedMeasureConfigs.forEach((measureConfig) => {
      measureConfig.layers.forEach((layer) => {
        if (mapRef.hasLayer(layer.geometryLayer)) return;
        if (measureConfig.measure.geometryType === "POINT") {
          if (radius && measureConfigId === measureConfig.id) {
            applyPointRadius(layer.geometryLayer, radius);
          }
          applyPointLayerStyle(layer.geometryLayer, measureConfig);
        } else {
          applyPolygonLayerStyle(layer.geometryLayer, measureConfig);
        }
        mapRef.addLayer(layer.geometryLayer);
      });
    });

    return function () {
      sortedMeasureConfigs.forEach((measureConfig) => {
        return measureConfig.layers.forEach((layer) =>
          layer.geometryLayer.remove()
        );
      });
    };
  }, [mapRef, sortedMeasureConfigs, radius, measureConfigId]);

  return (
    <span>
      {uniqueMeasures.map((measure) => (
        <TreeTrunkSvg measure={measure} key={measure.id} />
      ))}
    </span>
  );
}
